import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckinWaitingNumberSubHeaderComponent } from './checkin-waiting-number-sub-header.component';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [CheckinWaitingNumberSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, RouterModule],
  exports: [CheckinWaitingNumberSubHeaderComponent],
})
export class CheckinWaitingNumberSubHeaderModule {}
